/* bundle-discount-cart.js
 * ---------------------------------------------------------------------------
 * In-list bundle grouping + recommendation badges in the cart.
 *
 * Econ rework 2026-08 (WS4.4): the cart must show EXACTLY ONE nudge. The Liquid
 * totals row (snippets/bundle-savings-total.liquid -> bulg-cart-box-state.liquid)
 * owns the Bulg message, and marks the groups it covers with
 * [data-bundle-state-handle]; everything here skips those groups, which is what
 * keeps the count at one. Socksop, which still runs a percent ladder, is unaffected.
 *
 * Tier objects arrive straight from the collection metafield, so this file has to
 * read BOTH shapes: the legacy percent tier {qty, pct} and the amount-off tier
 * {qty, amount_off | amount_off_cents, pct_display} that WS2 writes. tierSaving() is
 * the single place that difference is resolved.
 */
(function() {
  'use strict';

  var BUNDLE_CONFIG_ID = 'bundle-discount-config';
  var BUNDLE_HEADER_CLASS = 'bundle-group-header';
  var BUNDLE_PROGRESS_CLASS = 'bundle-group-progress';

  function getConfig() {
    var el = document.getElementById(BUNDLE_CONFIG_ID);
    if (!el) return null;
    try {
      var config = JSON.parse(el.textContent);
      if (!config || Object.keys(config).length === 0) return null;
      return config;
    } catch (e) {
      return null;
    }
  }

  function removeBundleUI(container) {
    container.querySelectorAll('.' + BUNDLE_HEADER_CLASS + ', .' + BUNDLE_PROGRESS_CLASS).forEach(function(el) {
      el.remove();
    });
  }

  // The Liquid-rendered savings box above the product list already names the
  // group, its active tier and the next-tier nudge. Collect the handles it
  // covers so the in-list header/progress skip those groups instead of saying
  // the same thing twice.
  function coveredStateHandles(container) {
    var covered = {};
    var scope = container.closest('cart-drawer, main-cart');
    if (!scope) return covered;
    scope.querySelectorAll('.bundle-savings-total [data-bundle-state-handle]').forEach(function(el) {
      (el.getAttribute('data-bundle-state-handle') || '').split(',').forEach(function(h) {
        if (h) covered[h] = true;
      });
    });
    return covered;
  }

  function parseTiers(rawTiers) {
    var tiers = Array.isArray(rawTiers) ? rawTiers : (rawTiers && rawTiers.tiers ? rawTiers.tiers : []);
    return tiers.slice().sort(function(a, b) { return a.qty - b.qty; });
  }

  // How much a tier takes off, expressed for COPY. Amount-off tiers win when
  // present, because that is what the shopper actually pays less; percent tiers are
  // the legacy shape. Returns null when the tier saves nothing worth announcing.
  function tierSaving(tier) {
    if (!tier) return null;
    var cents = null;
    if (typeof tier.amount_off_cents === 'number') cents = tier.amount_off_cents;
    else if (typeof tier.amount_off === 'number') cents = Math.round(tier.amount_off * 100);
    if (cents != null && cents > 0) {
      var money = window.BulgLadder
        ? window.BulgLadder.money(cents)
        : '$' + (cents / 100).toFixed(2);
      return { text: money + ' off', rank: cents };
    }
    var pct = tier.pct_display || tier.pct;
    if (pct > 0) return { text: pct + '% off', rank: pct };
    return null;
  }

  function insertHeader(firstItem, label, activeTier) {
    var header = document.createElement('div');
    header.className = BUNDLE_HEADER_CLASS;
    header.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">' +
      '<path d="M243.31,136,144,36.69A15.86,15.86,0,0,0,132.69,32H40a8,8,0,0,0-8,8v92.69A15.86,15.86,0,0,0,36.69,144L136,243.31a16,16,0,0,0,22.63,0l84.68-84.68a16,16,0,0,0,0-22.63ZM80,96A16,16,0,1,1,96,80,16,16,0,0,1,80,96Z"/>' +
      '</svg>' +
      '<span>' + label + (activeTier ? ': ' + activeTier.label : '') + '</span>';
    firstItem.parentNode.insertBefore(header, firstItem);
  }

  function insertProgress(lastItem, nextTier, totalQty, activeTier, shopUrl) {
    var nextSaving = tierSaving(nextTier);
    var activeSaving = tierSaving(activeTier);
    if (nextTier && nextSaving) {
      var remaining = nextTier.qty - totalQty;
      var progress = document.createElement('div');
      progress.className = BUNDLE_PROGRESS_CLASS;
      var shopLink = shopUrl ? ' <a href="' + shopUrl + '">Shop more</a>' : '';
      progress.innerHTML = 'Add ' + remaining + ' more for ' + nextSaving.text + '!' + shopLink;
      if (lastItem.nextSibling) {
        lastItem.parentNode.insertBefore(progress, lastItem.nextSibling);
      } else {
        lastItem.parentNode.appendChild(progress);
      }
    } else if (activeTier && activeSaving) {
      var success = document.createElement('div');
      success.className = BUNDLE_PROGRESS_CLASS + ' ' + BUNDLE_PROGRESS_CLASS + '--success';
      success.textContent = '\u2713 ' + activeSaving.text + ' bundle discount applied!';
      if (lastItem.nextSibling) {
        lastItem.parentNode.insertBefore(success, lastItem.nextSibling);
      } else {
        lastItem.parentNode.appendChild(success);
      }
    }
  }

  function applySitewideGrouping(container, swConfig, covered) {
    var handles = swConfig.handles || [];
    var sortedTiers = parseTiers(swConfig.tiers);
    if (!sortedTiers.length) return;
    if (handles.some(function(h) { return covered[h]; })) return;

    var items = container.querySelectorAll('[data-bundle-collections]');
    if (!items.length) return;

    var totalQty = 0;
    var firstItem = null;
    var lastItem = null;

    items.forEach(function(item) {
      var collections = (item.getAttribute('data-bundle-collections') || '').split(',');
      var matches = handles.some(function(h) { return collections.indexOf(h) !== -1; });
      if (matches) {
        var qty = parseInt(item.getAttribute('data-item-qty') || '1', 10);
        totalQty += qty;
        if (!firstItem) firstItem = item;
        lastItem = item;
      }
    });

    if (totalQty === 0 || !firstItem) return;

    var activeTier = null;
    var nextTier = null;

    for (var i = sortedTiers.length - 1; i >= 0; i--) {
      if (totalQty >= sortedTiers[i].qty) {
        activeTier = sortedTiers[i];
        nextTier = sortedTiers[i + 1] || null;
        break;
      }
    }

    if (!activeTier) {
      nextTier = sortedTiers[0];
    }

    insertHeader(firstItem, swConfig.label || 'Socks Bundle', activeTier);
    insertProgress(lastItem, nextTier, totalQty, activeTier, '/collections');
  }

  function applyPerCollectionGrouping(container, config, covered) {
    var items = container.querySelectorAll('[data-bundle-collections]');
    if (!items.length) return;

    var handles = Object.keys(config).filter(function(k) { return k !== '_sitewide'; });

    for (var h = 0; h < handles.length; h++) {
      var handle = handles[h];
      if (covered[handle]) continue;
      var collectionConfig = config[handle];
      var sortedTiers = parseTiers(collectionConfig.tiers);
      if (!sortedTiers.length) continue;

      var totalQty = 0;
      var firstItem = null;
      var lastItem = null;

      items.forEach(function(item) {
        var collections = (item.getAttribute('data-bundle-collections') || '').split(',');
        if (collections.indexOf(handle) !== -1) {
          var qty = parseInt(item.getAttribute('data-item-qty') || '1', 10);
          totalQty += qty;
          if (!firstItem) firstItem = item;
          lastItem = item;
        }
      });

      if (totalQty === 0 || !firstItem) continue;

      var activeTier = null;
      var nextTier = null;

      for (var i = sortedTiers.length - 1; i >= 0; i--) {
        if (totalQty >= sortedTiers[i].qty) {
          activeTier = sortedTiers[i];
          nextTier = sortedTiers[i + 1] || null;
          break;
        }
      }

      if (!activeTier) {
        nextTier = sortedTiers[0];
      }

      insertHeader(firstItem, collectionConfig.label || handle, activeTier);
      insertProgress(lastItem, nextTier, totalQty, activeTier, collectionConfig.url);
    }
  }

  function applyBundleGrouping(container) {
    var config = getConfig();
    if (!config) return;

    removeBundleUI(container);

    var covered = coveredStateHandles(container);
    if (config._sitewide) {
      applySitewideGrouping(container, config._sitewide, covered);
    } else {
      applyPerCollectionGrouping(container, config, covered);
    }
  }

  // ─── Recommendation discount badges ──────────────────────────────────────
  // "You may also like" cards are more bundle-eligible socks. Adding one bumps
  // the bundle quantity, so each card advertises the discount the bundle reaches
  // when that item is added (tier at current-bundle-qty + 1).

  function savingForQty(sortedTiers, qty) {
    for (var i = sortedTiers.length - 1; i >= 0; i--) {
      if (qty >= sortedTiers[i].qty) return tierSaving(sortedTiers[i]);
    }
    return null;
  }

  // Build the bundle group(s) and the qty already in the cart for each, from the
  // real cart line items in `cartItems`.
  function computeGroups(cartItems) {
    var config = getConfig();
    if (!config || !cartItems) return [];
    var items = cartItems.querySelectorAll('[data-bundle-collections]');
    var groups = [];

    function tallyQty(matchFn) {
      var total = 0;
      items.forEach(function(item) {
        var cols = (item.getAttribute('data-bundle-collections') || '').split(',');
        if (matchFn(cols)) {
          total += parseInt(item.getAttribute('data-item-qty') || '1', 10);
        }
      });
      return total;
    }

    if (config._sitewide) {
      var sw = config._sitewide;
      var handles = sw.handles || [];
      groups.push({
        handles: handles,
        sortedTiers: parseTiers(sw.tiers),
        totalQty: tallyQty(function(cols) {
          return handles.some(function(h) { return cols.indexOf(h) !== -1; });
        })
      });
    } else {
      Object.keys(config).filter(function(k) { return k !== '_sitewide'; }).forEach(function(handle) {
        groups.push({
          handles: [handle],
          sortedTiers: parseTiers(config[handle].tiers),
          totalQty: tallyQty(function(cols) { return cols.indexOf(handle) !== -1; })
        });
      });
    }
    return groups;
  }

  function makeBadge(savingText) {
    var badge = document.createElement('div');
    badge.className = 'bundle-rec-badge';
    badge.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">' +
      '<path d="M243.31,136,144,36.69A15.86,15.86,0,0,0,132.69,32H40a8,8,0,0,0-8,8v92.69A15.86,15.86,0,0,0,36.69,144L136,243.31a16,16,0,0,0,22.63,0l84.68-84.68a16,16,0,0,0,0-22.63ZM80,96A16,16,0,1,1,96,80,16,16,0,0,1,80,96Z"/>' +
      '</svg>' +
      '<span>Add &rarr; ' + savingText + '</span>';
    return badge;
  }

  function annotateRecommendations(scope) {
    if (!scope) return;
    var cartItems = scope.querySelector('cart-items');
    var groups = computeGroups(cartItems);
    if (!groups.length) return;

    var slides = scope.querySelectorAll('cart-drawer-products-recommendation .swiper-slide[data-bundle-collections]');
    slides.forEach(function(slide) {
      var existing = slide.querySelector('.bundle-rec-badge');
      if (existing) existing.remove();

      var cols = (slide.getAttribute('data-bundle-collections') || '').split(',');
      var grp = null;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].handles.some(function(h) { return cols.indexOf(h) !== -1; })) { grp = groups[i]; break; }
      }
      if (!grp) return;

      var saving = savingForQty(grp.sortedTiers, grp.totalQty + 1);
      if (!saving) return;

      var info = slide.querySelector('.product-card__info');
      if (!info) return;
      var badge = makeBadge(saving.text);
      var price = info.querySelector('.f-price');
      if (price) {
        price.parentNode.insertBefore(badge, price.nextSibling);
      } else {
        info.appendChild(badge);
      }
    });
  }

  function annotateAllRecommendations() {
    document.querySelectorAll('cart-drawer, main-cart').forEach(annotateRecommendations);
  }

  function init() {
    var cartDrawer = document.querySelector('cart-drawer cart-items');
    if (cartDrawer) applyBundleGrouping(cartDrawer);

    var mainCart = document.querySelector('main-cart cart-items');
    if (mainCart) applyBundleGrouping(mainCart);

    annotateAllRecommendations();

    // Recommendation cards load asynchronously (and reload after each cart
    // change). The component dispatches a non-bubbling 'recommendations:loaded'
    // event — caught here in the capture phase, which fires for non-bubbling
    // events too. Re-badge that block once its cards are in the DOM.
    document.addEventListener('recommendations:loaded', function(e) {
      var scope = e.target.closest('cart-drawer, main-cart');
      if (scope) annotateRecommendations(scope);
    }, true);

    if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
      FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        function() {
          requestAnimationFrame(function() {
            var drawer = document.querySelector('cart-drawer cart-items');
            if (drawer) applyBundleGrouping(drawer);
            var main = document.querySelector('main-cart cart-items');
            if (main) applyBundleGrouping(main);
            annotateAllRecommendations();
          });
        }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
